import { DIMENSIONS } from '@hqo/react-components-library/dist/utils';
import styled from 'styled-components';

export const FilterSection = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  margin-bottom: 20px;

  @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    flex-direction: column;
  }
`;
